import * as PropTypes from 'prop-types';
import { MouseEvent } from 'react';
import { doNothingWithEvent } from '../../utils';

const PageNavigationLeftButtons = (props: {
    disabled?: boolean;
    onGoBack: (event: MouseEvent) => void;
    onGoToBeginning: (event: MouseEvent) => void;
    showGoToBeginning?: boolean;
}) => {
    const { disabled = false, onGoBack, onGoToBeginning, showGoToBeginning = true } = props;

    return (
        <>
            {showGoToBeginning && (
                <li className={disabled ? 'disabled' : ''}>
                    <a href="#" onClick={disabled ? doNothingWithEvent : onGoToBeginning}>
                        <i data-testid="pageable-single-arrow" className="fa fa-angle-left" />
                        <i data-testid="pageable-single-arrow" className="fa fa-angle-left" />
                    </a>
                </li>
            )}
            <li className={disabled ? 'disabled' : ''}>
                <a href="#" onClick={disabled ? doNothingWithEvent : onGoBack}>
                    <i data-testid="pageable-single-arrow" className="fa fa-angle-left" />
                </a>
            </li>
        </>
    );
};

PageNavigationLeftButtons.propTypes = {
    disabled: PropTypes.bool,
    showGoToBeginning: PropTypes.bool,
    onGoBack: PropTypes.func.isRequired,
    onGoToBeginning: PropTypes.func.isRequired
};

export default PageNavigationLeftButtons;
